// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopMenu_wrapper__UhmER","licence":"TopMenu_licence__2zS4x"};